<template>
  <div :id="'store' + idStore" class="notSelected">
    <section class="d-flex justify-content-end">
      <div v-if="!justView">
        <input
          v-if="isChecked"
          :class="hideCheckBox ? 'hideCheckBox' : ''"
          :id="idStore"
          style="cursor: pointer"
          type="checkbox"
          name="store"
          @change="$emit('isSelected', $event.target.checked, $el, $refs)"
          @click="
            $emit('clickStore', $event.target.checked, idStore, nameStore, $el)
          "
          checked
        />
        <input
          v-else
          :class="hideCheckBox ? 'hideCheckBox' : ''"
          :id="idStore"
          style="cursor: pointer"
          type="checkbox"
          name="store"
          @change="$emit('isSelected', $event.target.checked, $el, $refs)"
          @click="
            $emit('clickStore', $event.target.checked, idStore, nameStore, $el)
          "
        />
      </div>
    </section>
    <section class="d-flex justify-content-center align-items-center p-0">
      <span>
        <img
          :src="require('@/assets/images/svg/ícone-loja.svg')"
          alt=""
          style="margin-right: 10px"
        />
        <p
          style="
            margin: 0;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            color: var(--black-medium);
          "
        ></p>
      </span>
      <span>
        {{ nameStore }}
      </span>
    </section>
    <section
      v-if="newUsuario"
      class="mt-3 col-lg-12 d-flex justify-content-center"
    >
      <!-- <span class="textVerPerfil">Ver perfil</span> -->
      <button
        :id="'associar' + idStore"
        :ref="'associar' + idStore"
        class="btn btnAssociar"
        @click.prevent="selectedCheckBox"
      >
        {{ buttonAssociar === false ? "Associar" : "Desassociar" }}
      </button>
    </section>
  </div>
</template>
<script>
export default {
  name: "Store",
  props: {
    nameStore: String,
    valueInput: { type: Boolean, default: false },
    idStore: [String, Number],
    justView: { type: Boolean, default: false },
    newUsuario: { type: Boolean, default: false },
    revisao: { type: Boolean, default: false },
    hideCheckBox: { type: Boolean, default: false },
    changeTextButton: { type: Boolean, default: false },
    isChecked: { type: Boolean, default: false },
  },

  data() {
    return {
      buttonAssociar: this.changeTextButton,
      elementButtonAssociar: "",
    };
  },

  methods: {
    selectedCheckBox() {
      this.buttonAssociar = !this.buttonAssociar;
      document.getElementById(this.idStore).click();
    },
  },
};
</script>
<style scoped>
.btnAssociar {
  font-size: 1em !important;
  color: #2485ea !important;
  font-weight: 500 !important;
  background: #d3e7fb !important;
  padding: 2px 20px !important;
  transition: 0.5s !important;
  margin-left: 10px;
}
.btnAssociar:hover {
  color: #2485ea !important;
  background: #c2ddf8 !important;
}
.textVerPerfil {
  color: #2485ea !important;
}
</style>
<style>
.notSelected {
  border: 1px solid var(--grey-border);
}
.notSelected,
.selected {
  padding: 12px;
  margin: 5px;
  border-radius: 8px;
}
.selected {
  border: 1px solid var(--blue-medium);
  box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.07);
}
.hideCheckBox {
  opacity: 0 !important;
}
@media only screen and (min-width: 325px) and (max-width: 676px) {
  .notSelected,
  .selected {
    width: 224px;
  }
}
</style>
